import React from 'react';
import MandatoryAlertIcon from './MandatoryAlertIcon';

export default ({ trpl }) => {
  const hasWarnings = trpl && trpl.warnings && trpl.warnings[0];
  let warningsText = ``;

  if (trpl && trpl.warnings) {
    trpl.warnings.forEach((warning) => {
      warningsText += `${warning} \n`;
    });
  }

  if (!hasWarnings) return null;

  return <MandatoryAlertIcon tooltipText={warningsText} />;
};
